var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 98,
    viewBox: "0 0 139 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 132,
    height: 91,
    rx: 11.5,
    fill: "white",
    stroke: "#596B7B",
    strokeWidth: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 127,
    height: 17,
    fill: "#596B7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.56 78.64C43.0267 78.64 40.76 78.04 38.76 76.84C36.7867 75.64 35.24 73.9467 34.12 71.76C33 69.5467 32.44 66.96 32.44 64C32.44 61.0133 33 58.4267 34.12 56.24C35.24 54.0267 36.7867 52.32 38.76 51.12C40.76 49.8933 43.0267 49.28 45.56 49.28C47.9067 49.28 50.0133 49.8 51.88 50.84C53.7467 51.88 55.2533 53.3333 56.4 55.2L52.28 57.6C51.5333 56.4 50.5867 55.4667 49.44 54.8C48.32 54.1333 47.0267 53.8 45.56 53.8C43.9067 53.8 42.4533 54.2267 41.2 55.08C39.9467 55.9067 38.9733 57.0933 38.28 58.64C37.6133 60.16 37.28 61.9467 37.28 64C37.28 66.0267 37.6133 67.8133 38.28 69.36C38.9733 70.88 39.9467 72.0667 41.2 72.92C42.4533 73.7467 43.9067 74.16 45.56 74.16C47.0267 74.16 48.32 73.8267 49.44 73.16C50.5867 72.4933 51.5333 71.56 52.28 70.36L56.4 72.76C55.2533 74.6 53.7467 76.04 51.88 77.08C50.0133 78.12 47.9067 78.64 45.56 78.64ZM60.715 78V50H73.515C76.1283 50 78.195 50.6133 79.715 51.84C81.2617 53.0667 82.035 55.1333 82.035 58.04C82.035 60.9467 81.2617 63.0267 79.715 64.28C78.195 65.5333 76.1283 66.16 73.515 66.16H65.315V78H60.715ZM65.315 61.84H72.875C74.235 61.84 75.2883 61.5467 76.035 60.96C76.7817 60.3733 77.155 59.4 77.155 58.04C77.155 56.7067 76.7817 55.7467 76.035 55.16C75.2883 54.5733 74.235 54.28 72.875 54.28H65.315V61.84ZM85.9494 78V50H104.989V54.28H90.5494V61.56H103.749V65.88H90.5494V78H85.9494Z",
    fill: "#596B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpfIcon);
export default __webpack_public_path__ + "static/media/cpf-icon.64d2134bc0d97e8a7478dad6048abcd3.svg";
export { ForwardRef as ReactComponent };